import * as React from 'react';
import { EmptyState } from '@brightlayer-ui/react-components';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { RecordData, RecordDataState } from '../../hooks/data-hooks';
import { CenteredContent } from '../CenteredContent';

export const RecordDataErrorIndicator: React.FC<{ recordData: RecordData; message: string }> = (props) => {
    if (props.recordData.state !== RecordDataState.Error) {
        return null;
    }

    return (
        <CenteredContent>
            <EmptyState
                icon={
                    <div style={{ fontSize: 64 }}>
                        <ErrorOutlineIcon id="fail-icon" fontSize="inherit" />
                    </div>
                }
                title={props.message}
            />
        </CenteredContent>
    );
};
